import enterpriseFetch from 'enterprise-fetch';
import { RequestHandler } from 'express';

import { EntriesResult, MigrateRequest } from '~/services';

import mapAppErrorToObject from '~/transformations/mapAppErrorToObject';
import { Logger } from '~/util/logger';

export const callbackHandler: RequestHandler = async (req, res) => {
  try {
    const {
      payload,
      response,
    }: {
      payload?: MigrateRequest;
      response?: EntriesResult;
    } = res.locals;

    const { id, uri } = payload?.callback || {};

    if (uri) {
      const body = { id, response: JSON.stringify(response) };
      await enterpriseFetch(uri, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(body),
      });
    }
  } catch (ex: any) {
    Logger.error(`[callback] Error: ${mapAppErrorToObject(ex).message}`);
  }
};
